export enum CanvasShapeTypeEnum {
  POLYGON,
  LINE,
  RECTANGLE,
  CIRCLE,
}
